import makeTypeCreator from '@/models/makeTypeCreator'
const createType = makeTypeCreator('managers')

export const TOGGLE_SEARCH_DIALOG = createType('TOGGLE_SEARCH_DIALOG')
